import type { OrderResponse } from '../types';

/**
 * Renders a short label describing who cancelled the order.
 * Reads from {@code order.cancelledBy} (set by the backend in
 * OrderService.cancelOrder / OrderLifecycleService.reject):
 *   - OWNER    → "by you"
 *   - CUSTOMER → "by customer"
 *   - SYSTEM   → "by system"
 *   - null/unset → empty string (don't render)
 *
 * Use inline alongside the cancelled state copy:
 *   <span>Cancelled <CancelledByLabel order={order} /></span>
 */
export function CancelledByLabel({
  order,
  className,
}: {
  order: Pick<OrderResponse, 'cancelledBy'>;
  className?: string;
}) {
  const label = labelFor(order.cancelledBy);
  if (!label) return null;
  return <span className={className}>{label}</span>;
}

function labelFor(cancelledBy: OrderResponse['cancelledBy']): string {
  switch (cancelledBy) {
    case 'OWNER':
      return 'by you';
    case 'CUSTOMER':
      return 'by customer';
    case 'SYSTEM':
      return 'by system';
    default:
      return '';
  }
}
